import { useQuery } from '@tanstack/react-query';
import { Warehouse } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const WAREHOUSES_QUERY_KEY = ['warehouses'];

export const useWarehouses = () => {
  return useQuery<Warehouse[], Error>({
    queryKey: WAREHOUSES_QUERY_KEY,
    queryFn: async () => {
      const warehouses = await warehouseService.getWarehouses();
      return warehouses || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useWarehouses;
